module.exports = __webpack_public_path__ + "img/agricultura.46ce5f4e.svg";